import axios from 'axios'
import { createRouter, createWebHistory } from "vue-router"

// Importar páginas
import Login from './pages/LogiN'
import DashBoard from './pages/DashBoard'
import ProveedoresVue from './pages/mantenedores/ProveedoresVue'
import CategoriasVue from './pages/mantenedores/CategoriasVue'
import ProductosVue from './pages/mantenedores/ProductosVue'
import ModeloSerieFV from './pages/mantenedores/ModeloSerieFV'
import UnidadMedida from './pages/mantenedores/UnidadMedida'

import EmpresaVue from './pages/empresa/EmpresaVue'
import ComprobanteS from './pages/empresa/ComprobanteS'
import SucursaL from './pages/empresa/SucursaL'
import UsuarioS from './pages/empresa/UsuarioS'

import CompraS from './pages/inventario/CompraS'
import NuevaCompra from './pages/inventario/NuevaCompra'
import CompraDetalle from './pages/inventario/CompraDetalle'
import StocK from './pages/inventario/StocK'
import PrecioProducto from './pages/inventario/PrecioProducto'
import EntradaSalida from './pages/inventario/EntradaSalida'

import Pedidos from './pages/venta/ListarPedido'
import NuevoPedido from './pages/venta/NuevoPedido'
import DetallePedido from './pages/venta/DetallePedido'
import Caja from './pages/venta/CajA'
import Ventas from './pages/venta/VentaS'
import ReporteVentas from './pages/venta/ReporteVentas'
import DetalleVenta from './pages/venta/DetalleVenta'
import NotaCredito from './pages/venta/NotaCredito'
import NuevaNotaCred from './pages/venta/NuevaNotaCred'

// Rutas
const routes = [
    { path: '/login', name: 'login', component: Login },
    { path: '/dashboard', name: 'dashboard', component: DashBoard, meta: { requiresAuth: true } },
    { path: '/proveedores', name: 'proveedores', component: ProveedoresVue, meta: { requiresAuth: true } },
    { path: '/categorias', name: 'categorias', component: CategoriasVue, meta: { requiresAuth: true } },
    { path: '/productos', name: 'productos', component: ProductosVue, meta: { requiresAuth: true } },
    { path: '/modeloseriefv', name: 'modeloserie', component: ModeloSerieFV, meta: { requiresAuth: true } },
    { path: '/unidadmedida', name: 'unidadmedida', component: UnidadMedida, meta: { requiresAuth: true } },
    { path: '/configuracion', name: 'configuracion', component: EmpresaVue, meta: { requiresAuth: true } },
    { path: '/usuarios', name: 'usuarios', component: UsuarioS, meta: { requiresAuth: true } },
    { path: '/comprobantes', name: 'comprobantes', component: ComprobanteS, meta: { requiresAuth: true } },
    { path: '/sucursal', name: 'sucursal', component: SucursaL, meta: { requiresAuth: true } },
    { path: '/compras', name: 'compras', component: CompraS, meta: { requiresAuth: true } },
    { path: '/compras/nuevacompra', name: 'nuevacompra', component: NuevaCompra, meta: { requiresAuth: true } },
    { path: '/compras/detalle/:id', name: 'compradetalle', component: CompraDetalle, meta: { requiresAuth: true } },
    { path: '/stock', name: 'stock', component: StocK, meta: { requiresAuth: true } },
    { path: '/entradasalida', name: 'entradasalida', component: EntradaSalida, meta: { requiresAuth: true } },
    { path: '/precioproducto', name: 'precioproducto', component: PrecioProducto, meta: { requiresAuth: true } },
    { path: '/pedidos', name: 'pedidos', component: Pedidos, meta: { requiresAuth: true } },
    { path: '/pedidos/nuevo', name: 'nuevopedido', component: NuevoPedido, meta: { requiresAuth: true } },
    { path: '/pedidos/detalle/:id', name: 'detallepedido', component: DetallePedido, meta: { requiresAuth: true } },
    { path: '/caja', name: 'caja', component: Caja, meta: { requiresAuth: true } },
    { path: '/ventas', name: 'ventas', component: Ventas, meta: { requiresAuth: true } },
    { path: '/reporteventas', name: 'reporteventas', component: ReporteVentas, meta: { requiresAuth: true } },
    { path: '/ventas/detalle/:id', name: 'detalleventa', component: DetalleVenta, meta: { requiresAuth: true } },
    { path: '/notacredito/', name: 'notacredito', component: NotaCredito, meta: { requiresAuth: true } },
    { path: '/notacredito/nuevo', name: 'nuevanotacre', component: NuevaNotaCred, meta: { requiresAuth: true } },
]

// Crear router
const router = createRouter({
    history: createWebHistory(),
    routes
})

// Función para verificar autenticación
const isAuthenticated = async () => {
    const token = localStorage.getItem('access')
    if (!token) return false

    try {
        await axios.get('/api/auth/verificar_token/', {
            headers: { Authorization: `Bearer ${token}` }
        })
        return true
    } catch (error) {
        return false
    }
}

// Middleware de rutas
router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const auth = await isAuthenticated()
        if (auth) {
            next()
        } else {
            next('/login')
        }
    } else if (to.path === '/login') {
        const auth = await isAuthenticated()
        if (auth) {
            next('/dashboard')
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
